import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Header/Header";
import Sidebar from "../../Common/Sidebar/Sidebar";
import { toast } from "react-toastify";
import * as constantMessages from "../../../constants/constatntMessages";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../node_modules/axios/index";
import Loader from "../../Common/Loader";
import LoaderButton from "../../Common/LoaderButton";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Navigate, Link } from "react-router-dom";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import { encryptWithAES, decryptWithAES } from "../../../helpers/commonHelpers";

const SmtpSetUpClient = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const employeeData = useSelector((state) => state.user);
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const employeeDatas = useSelector((state) => state?.user);

  const accessToken = localStorage.getItem("accessToken");
  const organizationId = userData?.organizationId;


  const [serviceType, setServiceType] = useState("GMAIL");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showTokenIcon, setShowTokenIcon] = useState(true);
  const [gmailData, setGmailData] = useState({
    smtpHost: "",
    smtpPort: "",
    authUser: "",
    authPass: "",
    fromEmail: "",
    fromName: "",
    bccEmail: "",
    isDefault: false,
  });

  useEffect(() => {

    if (employeeData?.userData.isAdmin === false) {
      navigate("/pagenotfound");
    }
  }, [employeeData?.userData?.organizationId]);

  useEffect(() => {
    document.title = "SMTP: MinutesVault";
    getSmtpDetails();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    const lowercaseFields = ["smtpHost", "authUser", "fromEmail"];
    const updatedValue = lowercaseFields.includes(name)
      ? value.toLowerCase()
      : value;

    setGmailData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: null,
    }));
  };

  const getSmtpDetails = (e) => {
    setIsLoading(true);
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/smtp/getSmtpDetails/${organizationId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        setIsLoading(false);
        const resData = result?.data;
        if (resData?.success) {
      

          setGmailData({
            ...gmailData,
            smtpHost: resData?.data?.gmailsmtpCredentials?.smtpHost,
            smtpPort: Number(resData?.data?.gmailsmtpCredentials?.smtpPort),
            authUser: resData?.data?.gmailsmtpCredentials?.authUser,
            authPass: decryptWithAES(
              resData?.data?.gmailsmtpCredentials?.authPass
            ),
            fromEmail: resData?.data?.gmailsmtpCredentials?.fromEmail,
            fromName: resData?.data?.gmailsmtpCredentials?.fromName,
            bccEmail: resData?.data?.gmailsmtpCredentials?.bccEmail,
            isDefault: resData?.data?.isDefault,
          });
        } else {
          
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(constantMessages.serverErrorMessage + ' SMTP Setup', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const domainRegex =
    /^(?!:\/\/)(?=.{1,253}$)(?!-)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  const invalidDomainChars = /[<>()[\]{}"'`\\]/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
  const isOnlyNumbers = /^\d+$/;

  const smtpHostValidationCheck = () => {
    const newErrors = { ...errors };
    const host = gmailData.smtpHost?.trim() || "";

    const domainRegex =
      /^(?!:\/\/)(?=.{1,253}$)(?!-)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    const invalidCharactersRegex = /[<>()[\]{}"'`\\]/;

    if (!host) {
      newErrors.smtpHost = constantMessages.smtpHostRequired;
    } else if (invalidCharactersRegex.test(host)) {
      newErrors.smtpHost = constantMessages.invalidSmtpHost;
    } else if (!domainRegex.test(host)) {
      newErrors.smtpHost = constantMessages.invalidSmtpHost;
    } else {
      delete newErrors.smtpHost;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const smtpPortValidationCheck = () => {
    const newErrors = { ...errors };
    const port = Number(gmailData.smtpPort);

    if (!gmailData.smtpPort || String(gmailData.smtpPort).trim() === "") {
      newErrors.smtpPort = constantMessages.smtpPortRequired;
    } else if (isNaN(port) || port < 1 || port > 65535) {
      newErrors.smtpPort = constantMessages.invalidSmtpPort;
    } else {
      delete newErrors.smtpPort;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const authUserValidationCheck = () => {
    const newErrors = { ...errors };
    const authUser = gmailData.authUser?.trim() || "";

    if (!authUser) {
      newErrors.authUser = constantMessages.authUser;
    } else if (!emailRegex.test(authUser)) {
      newErrors.authUser = constantMessages.invalidAuthUser;
    } else {
      delete newErrors.authUser;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const authPassValidationCheck = () => {
    const newErrors = { ...errors };
    const pass = gmailData.authPass?.trim() || "";

    if (!pass) {
      newErrors.authPass = constantMessages.authPass;
    } else {
      delete newErrors.authPass;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const fromEmailValidationCheck = () => {
    const newErrors = { ...errors };
    const fromEmail = gmailData.fromEmail?.trim() || "";

    if (!fromEmail) {
      newErrors.fromEmail = constantMessages.fromEmail;
    } else if (!emailRegex.test(fromEmail)) {
      newErrors.fromEmail = constantMessages.invalidFromEmail;
    } else {
      delete newErrors.fromEmail;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const fromNameValidationCheck = () => {
    const newErrors = { ...errors };
    const fromName = gmailData.fromName?.trim() || "";

    if (!fromName) {
      newErrors.fromName = constantMessages.fromName;
    } else if (isOnlyNumbers.test(fromName)) {
      newErrors.fromName = "From Name cannot be only numbers";
    } else if (!excludeHtml.test(fromName)) {
      newErrors.fromName = constantMessages.invalidInput;
    } else if (fromName.length < 3 || fromName.length > 100) {
      newErrors.fromName = constantMessages.smtpFromName;
    } else {
      delete newErrors.fromName;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const validateSmtpForm = () => {
    const errors = {};
    const smtpHost = gmailData.smtpHost?.trim() || "";

    if (!smtpHost) {
      errors.smtpHost = constantMessages.smtpHostRequired;
    } else if (!domainRegex.test(smtpHost)) {
      errors.smtpHost = constantMessages.invalidSmtpHost;
    }

    const port = Number(gmailData.smtpPort);
    if (!gmailData.smtpPort || String(gmailData.smtpPort).trim() === "") {
      errors.smtpPort = constantMessages.smtpPortRequired;
    } else if (isNaN(port) || port < 1 || port > 65535) {
      errors.smtpPort = constantMessages.invalidSmtpPort;
    }

    if (!gmailData.authUser || gmailData.authUser.trim() === "") {
      errors.authUser = constantMessages.authUser;
    } else if (!emailRegex.test(gmailData.authUser)) {
      errors.authUser = constantMessages.invalidAuthUser;
    }

    if (!gmailData.authPass || gmailData.authPass.trim() === "") {
      errors.authPass = constantMessages.authPass;
    }

    if (!gmailData.fromEmail || gmailData.fromEmail.trim() === "") {
      errors.fromEmail = constantMessages.fromEmail;
    } else if (!emailRegex.test(gmailData.fromEmail)) {
      errors.fromEmail = constantMessages.invalidFromEmail;
    }

    const fromName = gmailData.fromName?.trim() || "";
    if (!fromName) {
      errors.fromName = constantMessages.fromName;
    } else if (isOnlyNumbers.test(fromName)) {
      errors.fromName = "From Name cannot be only numbers";
    } else if (!excludeHtml.test(fromName)) {
      errors.fromName = constantMessages.invalidInput;
    } else if (fromName.length < 3 || fromName.length > 100) {
      errors.fromName = constantMessages.smtpFromName;
    }

    setErrors(errors);
    console.log(errors);
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateSmtpForm();

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      console.log(newErrors);
      return;
    }
    setIsLoading(true);
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/smtp/updateSmtpDetails/${organizationId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    const payload = {
      ...gmailData,
      serviceType,
      isDefault: gmailData.isDefault,
      authPass: encryptWithAES(gmailData.authPass),
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((result) => {
        const resData = result?.data;
        if (resData?.success) {
          toast.success(resData?.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          getSmtpDetails();
        } else {
          toast.error(resData?.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(constantMessages.serverErrorMessage + ' SMTP Setup', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const showToken = (id) => {
    setShowTokenIcon(!showTokenIcon);
    var x = document.getElementById(id);
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  return (
    <div>
      <div className="main-content">
        <div className="Action-list-page">
          <div className="meeting-header-text">
            <h4>SMTP Configuration</h4>
          </div>
          <div className="mt-2 table-box responsive-table">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="mb-1">
                    Service Type<span className="star-mark"> *</span>
                  </label>

                  <select
                    className="fltr-opt"
                    aria-placeholder="Select Host"
                    name="hostName"
                    value={serviceType}
                  >
                    <option value={"GMAIL"}>Gmail</option>
                  </select>
                </div>
              </div>
            </div>
            {!isLoading ? (
              <>
                {serviceType === "GMAIL" ? (
                  <div className="meeting-form">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <label className="mb-1">
                            SMTP Host<span className="star-mark"> *</span>
                          </label>
                          <input
                            type="text"
                            name="smtpHost"
                            autoComplete="off"
                            value={gmailData.smtpHost}
                            onChange={handleChange}
                            placeholder="Enter SMTP Host Name"
                            onBlur={smtpHostValidationCheck}
                          />
                          {errors.smtpHost && (
                            <span className="error-message">
                              {errors.smtpHost}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <div>
                            <label className="mb-1">
                              SMTP PORT <span className="star-mark"> *</span>
                            </label>
                            <input
                              type="number"
                              name="smtpPort"
                              autoComplete="off"
                              value={gmailData.smtpPort}
                              onChange={handleChange}
                              placeholder="Enter SMTP Port"
                              onBlur={smtpPortValidationCheck}
                            />
                            {errors.smtpPort && (
                              <span className="error-message">
                                {errors.smtpPort}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <div>
                            <label className="mb-1">
                              From Email <span className="star-mark"> *</span>
                            </label>
                            <input
                              type="text"
                              name="fromEmail"
                              autoComplete="off"
                              value={gmailData.fromEmail}
                              onChange={handleChange}
                              placeholder="Enter From Email"
                              onBlur={fromEmailValidationCheck}
                            />
                            {errors.fromEmail && (
                              <span className="error-message">
                                {errors.fromEmail}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <div>
                            <label className="mb-1">
                              From Name <span className="star-mark"> *</span>
                            </label>
                            <input
                              type="text"
                              name="fromName"
                              autoComplete="off"
                              value={gmailData.fromName}
                              onChange={handleChange}
                              placeholder="Enter From Name"
                              onBlur={fromNameValidationCheck}
                            />
                            {errors.fromName && (
                              <span className="error-message">
                                {errors.fromName}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                   
                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <div>
                            <label className="mb-1">
                              Auth User (Email){" "}
                              <span className="star-mark"> *</span>
                            </label>
                            <input
                              type="text"
                              name="authUser"
                              autoComplete="off"
                              value={gmailData.authUser}
                              onChange={handleChange}
                              placeholder="Enter Email"
                              onBlur={authUserValidationCheck}
                            />
                            {errors.authUser && (
                              <span className="error-message">
                                {errors.authUser}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6">
                        <div className="form-group">
                          <div className="pwd-group1">
                            <label className="mb-1">
                              Auth Password{" "}
                              <span className="star-mark"> *</span>
                            </label>
                            <div className="inner-group input">
                              {!showTokenIcon ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-eye"
                                  viewBox="0 0 16 16"
                                  onClick={() => showToken("secretToken")}
                                >
                                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-eye-slash"
                                  viewBox="0 0 16 16"
                                  onClick={() => showToken("secretToken")}
                                >
                                  <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                  <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                  <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                </svg>
                              )}
                              <input
                                type="password"
                                name="authPass"
                                autoComplete="off"
                                value={gmailData.authPass}
                                onChange={handleChange}
                                placeholder="Enter Password"
                                id="secretToken"
                                className="show-token"
                                onBlur={authPassValidationCheck}
                              />
                            </div>
                            {errors.authPass && (
                              <span className="error-message">
                                {errors.authPass}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="meeting-organiser d-flex align-items-center dynamic-checkbox">
                        <input
                          type="checkbox"
                          name="isDefault"
                          className="dynamic-checkbox"
                          checked={gmailData.isDefault}
                          onChange={(e) =>
                            setGmailData({
                              ...gmailData,
                              isDefault: e.target.checked,
                            })
                          }
                        />
                        <span>Set as Default</span>
                      </div>
                    </div>
                    {isLoading ? (
                      <LoaderButton />
                    ) : (
                      <button
                        className="create-meeting-button Mom-btn mt-4"
                        disabled={isLoading}
                        type="button"
                        onClick={handleSubmit}
                      >
                        <p>Submit</p>
                      </button>
                    )}
                  </div>
                ) : null}
              </>
            ) : (
              <div
                className="meeting-page "
                style={{ textAlign: "center", paddingTop: 20 }}
              >
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmtpSetUpClient;
